import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import "../css/Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-bg" />

      <div className="footer-container">
        {/* Brand */}
        <div className="footer-brand">
          <h2 className="footer-logo">Inquizene</h2>
          <p>
            We design and build modern software systems that help organizations
            operate clearly, scale responsibly, and evolve with confidence.
          </p>
        </div>

        {/* Links */}
        <div className="footer-links">
          <h4>Company</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/solutions">Solutions</a></li>
            <li><a href="/pricing">Pricing</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <ul>
            <li>contact@inquizene.com</li>
            <li>Bengaluru, India</li>
          </ul>
        </div>

        {/* Social */}
        <div className="footer-social">
          <h4>Connect</h4>
          <div className="social-icons">
            <a href="https://facebook.com/inquizene"><FaFacebookF /></a>
            <a href="https://twitter.com/inquizene"><FaTwitter /></a>
            <a href="https://linkedin.com/in/inquizene"><FaLinkedinIn /></a>
            <a href="https://instagram.com/inquizeneofficial"><FaInstagram /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Inquizene. All rights reserved.
      </div>
    </footer>
  );
}
